<div class="flex h-full flex-col items-center gap-6 px-10 pt-6 shadow-notes-list">
  <div class="flex h-10 w-full">
    <lib-input
      class="min-w-0 text-text-light"
      placeholder="{{ 'notes_search_input_placeholder' | translate }}"
      [value]="searchTerm()"
      (valueChange)="onSearchTermChange($event)"
    >
      <svg-icon key="px-24-search" class="text-text-light" leftIcon></svg-icon>
      @if (searchTerm() && searchTerm()!.length > 0) {
        <svg-icon key="px-24-cancel" class="cursor-pointer text-text-light" rightIcon (click)="onClearSearchTermClick()"></svg-icon>
      }
    </lib-input>
  </div>
  @if (!isLoading()) {
    @if (items().length) {
      <div
        cdkScrollable
        class="flex h-full w-full flex-col items-center overflow-y-scroll pr-3"
        libInfiniteScrollList
        (endReached)="onEndReached()"
      >
        @for (group of items(); track group.visitId) {
          <lib-ffd-note-visit
            class="w-full"
            [items]="group.notes"
            [visitDate]="group.groupDate"
            [searchTerm]="searchTerm()"
            [selectedNoteId]="selectedNoteId()"
            (noteClick)="onNoteClick($event)"
            (editNoteClick)="onEditNoteClick($event)"
            (deleteNoteClick)="onDeleteNoteClick($event)"
            libInfiniteScrollListItem
          />
        }
        @if (infiniteScrollLoading()) {
          @for (item of infiniteScrollLoadingSkeletons(); track $index) {
            <div class="mb-4 h-40 w-full flex-shrink-0 animate-pulse rounded-3xl bg-background-light-grey"></div>
          }
        }
      </div>
    }
    @if (!items().length && !isLoading()) {
      <div class="flex h-full flex-col items-center justify-center">
        <div class="flex flex-col items-center justify-between gap-4">
          <div class="flex h-14 w-14 items-center justify-center rounded-full bg-background-extra-light/30 text-text-light">
            <svg-icon [key]="'px-24-search'"></svg-icon>
          </div>
          <div class="typo-h4-light text-center text-text-light">
            {{ 'notes_empty_group_label_searched' | translate }}
          </div>
        </div>
      </div>
    }
  }
  @if (isLoading()) {
    @for (item of loadingSkeletons(); track $index) {
      <div class="h-40 w-full animate-pulse rounded-3xl bg-background-light-grey"></div>
    }
  }
</div>
